<ng-container [ngSwitch]="layout">
    <ng-container *ngSwitchCase="'default'">
        <div [hidden]="amountHidden" [ngClass]="useGrid ? 'col-2' : 'flex-fill mr-3'">
            <ng-container *ngTemplateOutlet="amountTemplate"></ng-container>
        </div>
        <div [ngClass]="useGrid ? (amountHidden ? 'col-12' : 'col-8') : 'flex-fill'">
            <ng-container *ngTemplateOutlet="intervalTemplate"></ng-container>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="'reverse'">
        <div [ngClass]="useGrid ? (amountHidden ? 'col-12' : 'col-8') : 'flex-fill'">
            <ng-container *ngTemplateOutlet="intervalTemplate"></ng-container>
        </div>
        <div [hidden]="amountHidden" [ngClass]="useGrid ? 'col-2' : 'flex-fill ml-3'">
            <ng-container *ngTemplateOutlet="amountTemplate"></ng-container>
        </div>
    </ng-container>
</ng-container>


<ng-template #amountTemplate>
    <div>
        <ng-content select="[amount-label]"></ng-content>
        <div class="mb-1 font-size-12 default-amount-label" cvLocalizedText langSection="Controls" langKey="Amount_Title">Amount</div>
    </div>
    <select *ngIf="!useCxOne" [attr.id]="('module-' + stateKey + '-Settings-IntervalAmount') | cleanId" class="form-control" [(ngModel)]="settingsManager.intervalAmt" (ngModelChange)="onIntervalChanged()" [disabled]="intervalNoAmount.has(settingsManager.intervalType)">
        <option *ngFor="let amount of intervalAmountsMap.get(settingsManager.intervalType)" [ngValue]="amount.id">{{ amount.name }}</option>
    </select>
    <sol-dropdown *ngIf="useCxOne"
        [id]="('module-' + stateKey + '-Settings-IntervalAmount') | cleanId"
        [disabled]="intervalNoAmount.has(settingsManager.intervalType)"
        [(ngModel)]="intervalAmtCxOne" [options]="intervalAmountsMap.get(settingsManager.intervalType)"
        (ngModelChange)="onIntervalChanged()"
        label="name"
        primaryKey="id"
        [required]="false"
        [showFooter]="false"
        [searchEnabled]="false"
        ></sol-dropdown>
</ng-template>

<ng-template #intervalTemplate>
    <div>
        <ng-content select="[interval-label]"></ng-content>
        <div class="mb-1 font-size-12 default-interval-label" cvLocalizedText langSection="Controls" langKey="Interval_Title">Interval</div>
    </div>
    <select *ngIf="!useCxOne" [attr.id]="('module-' + stateKey + '-Settings-IntervalType') | cleanId" class="form-control" [(ngModel)]="settingsManager.intervalType" (ngModelChange)="onIntervalChanged()">
        <option *ngFor="let type of intervalTypes" [ngValue]="type.id">{{ type.name }}</option>
    </select>
    <sol-dropdown *ngIf="useCxOne"
        [id]="('module-' + stateKey + '-Settings-IntervalType') | cleanId"
        [(ngModel)]="intervalTypeCxOne" [options]="intervalTypes"
        (ngModelChange)="onIntervalChanged()"
        label="name"
        primaryKey="id"
        sortKey="order"
        [required]="false"
        [showFooter]="false"
        [searchEnabled]="false"
        ></sol-dropdown>
</ng-template>